import React from 'react';
import { FaPhoneAlt, FaWhatsapp, FaTimes, FaHeadset, FaUserTie } from 'react-icons/fa';

const SupportPopup = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center px-4">
      {/* Backdrop */}
      <div 
        className="absolute inset-0 bg-slate-900/60 backdrop-blur-sm transition-opacity"
        onClick={onClose}
      ></div>
      
      {/* Modal */}
      <div className="bg-white rounded-[2rem] w-full max-w-md relative z-10 overflow-hidden shadow-2xl animate-fade-in-up">
        {/* Header */}
        <div className="bg-gradient-to-r from-slate-800 to-slate-900 p-6 sm:p-8 text-white relative">
          <div className="absolute top-0 right-0 w-32 h-32 bg-orange-500/20 rounded-full -mr-10 -mt-10 blur-2xl"></div>
          
          <button 
            onClick={onClose}
            className="absolute top-5 right-5 w-8 h-8 flex items-center justify-center bg-white/10 hover:bg-white/20 rounded-full transition-colors z-10"
          >
            <FaTimes />
          </button>
          
          <div className="relative z-10">
            <h3 className="text-xl sm:text-2xl font-black mb-1.5 flex items-center gap-2">
              <FaHeadset className="text-orange-500" />
              Need Assistance?
            </h3>
            <p className="text-slate-300 text-[11px] sm:text-xs font-medium">
              Choose the right department to get your issue resolved quickly.
            </p>
          </div>
        </div>

        {/* Content */}
        <div className="p-6 sm:p-8 space-y-4">
          
          

          {/* Teacher/Class Support */}
          <div className="group bg-slate-50 hover:bg-orange-50/50 rounded-2xl p-5 border border-slate-100 hover:border-orange-200 transition-all shadow-sm">
            <div className="flex items-start gap-4">
              <div className="w-12 h-12 bg-orange-100 text-orange-600 rounded-xl flex items-center justify-center text-xl shrink-0 group-hover:scale-110 transition-transform shadow-inner">
                <FaUserTie />
              </div>
              <div className="flex-1">
                <h4 className="font-black text-slate-800 text-sm mb-1">Kasun Walakumbura</h4>
                <p className="text-slate-500 text-[10px] sm:text-[11px] mb-3 leading-relaxed font-medium">For subject matters, class schedules, or academic inquiries.</p>
                
                <div className="flex items-center gap-2">
                  <a href="tel:0740251710" className="flex-1 flex items-center justify-center gap-2 py-2.5 bg-white border border-slate-200 rounded-xl text-slate-700 text-xs font-bold hover:bg-slate-50 transition-colors shadow-sm">
                    <FaPhoneAlt className="text-slate-400" /> 074 025 1710
                  </a>
                  <a href="https://wa.me/94740251710" target="_blank" rel="noreferrer" className="w-10 h-10 flex items-center justify-center bg-[#25D366] text-white rounded-xl hover:bg-[#20bd5a] transition-colors shadow-sm shadow-green-200 shrink-0">
                    <FaWhatsapp size={16} />
                  </a>
                </div>
              </div>
            </div>
          </div>
{/* IT Support */}
          <div className="group bg-slate-50 hover:bg-blue-50/50 rounded-2xl p-5 border border-slate-100 hover:border-blue-200 transition-all shadow-sm">
            <div className="flex items-start gap-4">
              <div className="w-12 h-12 bg-blue-100 text-blue-600 rounded-xl flex items-center justify-center text-xl shrink-0 group-hover:scale-110 transition-transform shadow-inner">
                <FaHeadset />
              </div>
              <div className="flex-1">
                <h4 className="font-black text-slate-800 text-sm mb-1">IT Support</h4>
                <p className="text-slate-500 text-[10px] sm:text-[11px] mb-3 leading-relaxed font-medium">For technical issues, login problems, payments, or website bugs.</p>
                
                <div className="flex items-center gap-2">
                  <a href="tel:0768582057" className="flex-1 flex items-center justify-center gap-2 py-2.5 bg-white border border-slate-200 rounded-xl text-slate-700 text-xs font-bold hover:bg-slate-50 transition-colors shadow-sm">
                    <FaPhoneAlt className="text-slate-400" /> 076 858 2057
                  </a>
                  <a href="https://wa.me/94768582057" target="_blank" rel="noreferrer" className="w-10 h-10 flex items-center justify-center bg-[#25D366] text-white rounded-xl hover:bg-[#20bd5a] transition-colors shadow-sm shadow-green-200 shrink-0">
                    <FaWhatsapp size={16} />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SupportPopup;
